"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const topics = [{
  ordinalLabel: "01 — PAINÉIS DE MADEIRA",
  title: "Cimento",
  description: "Otimize operações de pulverização como o arrefecimento de gases em torres de condicionamento e arrefecedores de clínquer, bem como a supressão de poeiras.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.08.png?v=tvezqvlg36o",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.08.png?v=zqm0vkptvy-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.08.png?v=6z20mv9ivc6-wvc-sizes",
  alt: "Sistema de pulverização de precisão em linha de produção de painéis de madeira"
}, {
  ordinalLabel: "02 — CIMENTO E BETÃO",
  title: "Engenharia de Madeiras",
  description: "Aplique resina, cera, agentes de desmoldagem, marcas de pregos e muito mais com precisão.",
  image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.37.png?v=hjtg81kh89e",
  srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.37.png?v=bn7ep7awpfc-wvc-srcset",
  sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-17.13.37.png?v=6eob2nfr68b-wvc-sizes",
  alt: "Controlo de poeiras e pulverização de desmoldantes em fábrica de cimento e betão"
}];
export default function Industrycasestudy() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".sw-header-eyebrow", {
        y: 16,
        opacity: 0
      });
      gsap.set(".sw-header-title", {
        y: 24,
        opacity: 0
      });
      gsap.set(".sw-card", {
        y: 32,
        opacity: 0
      });
      gsap.to(".sw-header-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.7,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".sw-header-title", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        delay: 0.1,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".sw-card", {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.15,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".sw-grid",
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".sw-header-eyebrow", ".sw-header-title", ".sw-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="31389" id="industrycasestudy" data-nav="dark" className="bg-background text-foreground py-24 md:py-36 overflow-hidden">
      <div ref={container} className="mx-auto max-w-[1360px] px-5 sm:px-8 md:px-12 lg:px-14">
        {}
        <div className="text-center mb-16 md:mb-20">
          <div className="sw-header-eyebrow inline-flex items-center justify-center text-xs uppercase tracking-[0.22em] font-medium text-muted-foreground mb-4" style={{
          opacity: 0
        }}>As operações de pulverização no fabrico de materiais de construção exigem precisão e eficiência. Os fabricantes necessitam dos bicos de pulverização, sistemas de pulverização automatizados, lanças de pulverização e pistolas de pulverização de alta pressão adequados para obter os resultados pretendidos. A Spraying Systems Co. dispõe de todos eles.</div>
          <h2 className="sw-header-title font-default text-foreground mx-auto max-w-[22ch]" style={{
          opacity: 0,
          fontSize: "clamp(2rem, 4vw, 3.5rem)",
          lineHeight: 1.1,
          letterSpacing: "-0.02em",
          fontWeight: 600
        }}>
            {"Soluções de pulverização para Madeiras e Cimentos."}
          </h2>
        </div>

        {}
        <div className="sw-grid grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {topics.map((topic, i) => <div key={i} data-index={i} className="sw-card bg-card border border-border rounded-3xl p-6 sm:p-7 flex flex-col shadow-xs transition-shadow duration-300 hover:shadow-md" style={{
          opacity: 0
        }}>
              {}
              <div className="relative w-full aspect-[3/2] overflow-hidden rounded-xl mb-6 bg-muted">
                <img src={topic.image} data-wvc-srcset={topic.srcset} data-wvc-sizes={topic.sizes} alt={topic.alt} loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 hover:scale-[1.03]" />
              </div>

              {}
              <div className="text-xs uppercase tracking-wider font-medium text-muted-foreground mb-3">
                {topic.ordinalLabel}
              </div>

              {}
              <h3 className="font-default text-xl sm:text-2xl font-semibold text-foreground mb-3 leading-snug">
                {topic.title}
              </h3>

              {}
              <p className="font-default text-sm sm:text-base text-muted-foreground leading-relaxed text-left">
                {topic.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}